import { lazy } from "react";

const AuthLogin = lazy(() => import("layouts/authentication/log-in"));
const AuthRegister = lazy(() => import("layouts/authentication/register"));
// const HomePage = lazy(() => import("layouts/pages/Landing"));
const JobSearch = lazy(() => import("layouts/pages/JobSearch"));
const JobDetails = lazy(() => import("layouts/pages/JobDetails"));
const SingleProfile = lazy(() => import("layouts/pages/SingleProfile"));
const LaunchPage = lazy(() => import("layouts/pages/LaunchPage"));
const NewLandingPage = lazy(() => import("layouts/pages/NewLandingPage"));
const DynamicLandingPage = lazy(() => import("layouts/pages/DynamicLandingPage"));
const ContentDetails = lazy(() => import("layouts/pages/configurations/ContentDetails"));

const LoginRoutes = (role) => {
  return [
    {
      path: "/",
      // element: role.includes("Administrator") ? <JobSearch /> : <NewLandingPage />,
      element: <DynamicLandingPage />,
    },
    {
      path: "/sign-in",
      element: <AuthLogin />,
    },
    {
      path: "/sign-up",
      element: <AuthRegister />,
    },
    // {
    //   path: "/landing",
    //   element: <HomePage />,
    // },
    {
      path: "/jobs",
      element: <JobSearch />,
    },
    {
      path: `/jobs/:job_id`,
      element: <JobDetails />,
    },
    {
      path: "/profile-creation",
      element: <SingleProfile />,
    },
    {
      path: "/l",
      element: <LaunchPage />,
    },
    {
      path: "/new-landing",
      element: <NewLandingPage />,
    },
    {
      path: `/panel/:panel_id`,
      element: <ContentDetails />,
    },
    // {
    //   path: "/privacy-policy",
    //   element: <PrivacyPolicy />,
    // },
    // {
    //   path: "/terms-conditions",
    //   element: <TermsConditions />,
    // },
    // {
    //   path: "/contact-us",
    //   element: <ContactUs />,
    // },
  ];
};

export default LoginRoutes;
